import React from 'react'

// Import common components
import { Box, FlexBox } from '../../common/Box'
import Description from '../../common/Description'
import Title from '../../common/Title'
import Icon from '../../common/Icon'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'

// import custom styled components
import { ServicesWrapper, MainSectionWrapper, ServiceListWrapper, ServiceItemWrapper, ServiceIcon } from './ServiceResponsive'

import { DATA } from '../../../constants/data'

const styles = {
  childWidth: '100%',
  wrapperWidth: '100%',
  paddingRight: `${px2Rem(70)}`,
  border: `1px solid ${COLORS.red}`
}

/**
 * Render Service Item with these params
 * @param {string} width
 * @param {string} height
 * @param {string} typeTitle
 * @param {string} typeDescription
 * @param {string} title
 * @param {string} text
 * @param {string} index
 * @param {string} icon
 */
const ServiceItem = (width, href, typeTitle, typeDescription, title, text, index, icon, paddingRight) => {
  return (
    <ServiceItemWrapper icon={icon} width={width} paddingRight={paddingRight}>
      <FlexBox
        alignItems='center'
        style={{ marginTop: icon ? px2Rem(20) : '' }}
      >
        <ServiceIcon icon={icon}>
          {icon && (
            <Icon
              src={icon}
              customStyle={{
                marginBottom: '0',
                width: '100%',
                height: '100%'
              }}
            />
          )}
        </ServiceIcon>
        <Title
          type={typeTitle}
          title={title}
          style={{width: !icon ? px2Rem(180) : ''}}
        />
      </FlexBox>
      <Description
        type='xxTiny'
        text={text}
      />
    </ServiceItemWrapper>
  )
}

const renderMainSection = () => {
  return (
    <MainSectionWrapper>
      {
        ServiceItem(
          styles.childWidth,
          '#',
          'xSmall',
          'base',
          'Our Services',
          'We are a group of game designers and engineers that truly love gaming. We work very closely with our clients to build games that have amazing user experience, exciting storylines, and engaging interactions so that gamers walk away always wanting more.',
          'index'
        )
      }
    </MainSectionWrapper>
  )
}

const renderListServices = ({ data }) => {
  const limitData = data.slice(0, DATA.MAX_SERVICES)
  return (
    <ServiceListWrapper limitData={limitData}>
      {
        limitData.map((item, index) => {
          return (
            <Box key={index} >
              {
                ServiceItem(
                  styles.wrapperWidth,
                  item.node.slug,
                  'xTiny',
                  'small',
                  item.node.name,
                  item.node.description.description,
                  'index',
                  item.node.icon.file.url,
                  styles.paddingRight
                )
              }
            </Box>
          )
        })
      }
    </ServiceListWrapper>
  )
}

const Services = ({ data, id }) => {
  return (
    <ServicesWrapper id={id}>
      {renderMainSection()}
      {renderListServices({ data })}
    </ServicesWrapper>
  )
}

export default Services



// WEBPACK FOOTER //
// ./src/components/sections/services/Services.js